import { useOfferCart, useSelectedStep } from '@fhs/loyalty/src/state/offer-guide-cart-state';
import { ICartEntry } from '@rbi-ctg/menu';
import { useIsEditCartEnabled } from 'hooks/use-is-edit-cart-enabled';
import { useFavoritesContext } from 'state/favorites';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useMenuContext } from 'state/menu';
import { useOrderContext } from 'state/order';

import { useProductWizardContext } from '../index';

import useProductWizardFlow from './use-product-wizard-flow';

export const useEditingCartEntry = (isSimplyOffer?: boolean): ICartEntry | undefined => {
  const selectedStep = useSelectedStep();
  const { isEdit: isSimplyOfferEdit } = useOfferCart();

  const enableFavorites = useFlag(LaunchDarklyFlag.ENABLE_FAVORITES);
  const { isOffer } = useMenuContext();
  const { isEdit, isFavorite } = useProductWizardFlow();
  const { isSimplyOffer: isSimplyOfferFromContext } = useProductWizardContext();
  const finalIsSimplyOffer = isSimplyOffer ?? isSimplyOfferFromContext;
  const enableEditCart = useIsEditCartEnabled({ cartHasIncentive: isOffer });
  const { getCurrentCartEntry, cartIdEditing } = useOrderContext();
  const { currentCartEntry: currentFavoriteEntry, tempFavorite: currentFavorite } =
    useFavoritesContext();
  const isEditing =
    (finalIsSimplyOffer && isSimplyOfferEdit) ||
    (isFavorite && currentFavorite ? enableFavorites : enableEditCart && isEdit && cartIdEditing);
  const editingCartEntry = finalIsSimplyOffer
    ? selectedStep?.selectedEntry
    : currentFavorite
      ? currentFavoriteEntry
      : getCurrentCartEntry(isOffer);

  return isEditing ? editingCartEntry : undefined;
};
